export default class Conversion {
  constructor(data) {
    Object.assign(this, data);
  }
}
